//
import { UserSellerModel } from '@/models'

/**
 *
 */
const create = async function(data) {
    //
    try {
        //
        const response = await new UserSellerModel(data).save()

        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default create
